import { nonUndefined } from "Utility";
import {
  TimeAttackScoringAverage,
  isTimeAttackScoringAverage,
  getTimeAttackAverageScore,
} from "./TimeAttackScoringAverage";
import {
  TimeAttackScoringSum,
  isTimeAttackScoringSum,
  getTimeAttackSumScore,
} from "./TimeAttackScoringSum";
import { AdjustedTime, combineAdjustedTimes } from "model/Match/AdjustedTime";
import { TimeAttackScoringPoints } from "./TimeAttackScoringPoints";

export type TimeAttackScoringType = "Average" | "Points" | "Sum";

export const isTimeAttackScoringType = (
  value: string
): value is TimeAttackScoringType => {
  return ["Average", "Points", "Sum"].includes(value);
};

export type TimeAttackScoringBase = {
  type: TimeAttackScoringType;
};

export type TimeAttackScoring =
  | TimeAttackScoringAverage
  | TimeAttackScoringPoints
  | TimeAttackScoringSum;

export const calculateTimeAttackTeamPointsScoring = (
  teamTime: number | undefined,
  sortedTimes: (number | undefined)[],
  scoring: TimeAttackScoringPoints
) => {
  if (
    (!teamTime || teamTime === -1) &&
    scoring.points.dnfPoints !== undefined
  ) {
    return scoring.points.dnfPoints;
  }

  var positionIndex = sortedTimes.indexOf(teamTime);
  while (positionIndex > 0 && sortedTimes[positionIndex - 1] === teamTime) {
    positionIndex--;
  }

  return scoring.points.distribution.at(positionIndex);
};

export const calculateTimeAttackTeamScoring = (
  teamRoundTimes: (AdjustedTime | undefined)[][],
  scoring: TimeAttackScoring
) => {
  const combinedTimes = teamRoundTimes.map((roundTimes) => {
    const finishTimes = nonUndefined(roundTimes);
    if (finishTimes.length > 0) {
      return combineAdjustedTimes(finishTimes);
    }

    return undefined;
  });

  return calculateTimeAttackScoring(combinedTimes, scoring);
};

export const calculateTimeAttackScoring = (
  roundTimes: (AdjustedTime | undefined)[],
  scoring: TimeAttackScoring
) => {
  if (isTimeAttackScoringSum(scoring)) {
    return getTimeAttackSumScore(roundTimes);
  }

  if (isTimeAttackScoringAverage(scoring)) {
    return getTimeAttackAverageScore(roundTimes, scoring);
  }
};
